import { makeStyles } from '@material-ui/core/styles'
import { getPixelInREM } from '../../common/material'

export const useReportMenuCommonLayoutLoadingStateStyles = makeStyles(
    (theme) => ({
        container: {
            width: '100%',
            margin: `0 ${getPixelInREM(20)}`
        },
        headerContainer: {
            padding: `${getPixelInREM(10)} ${getPixelInREM(10)}`,
            display: 'grid',
            gridAutoFlow: 'column',
            gap: 12
        },
        subheaderContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        title: {
            fontSize: getPixelInREM(30),
            fontWeight: 600,
            lineHeight: getPixelInREM(36),
            color: theme.palette.primary.main,
            marginBottom: getPixelInREM(3)
        },
        subTitle: {
            margin: 0,
            fontSize: getPixelInREM(16),
            color: theme.palette.grey[400],
            lineHeight: getPixelInREM(19)
        },
        filterContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: getPixelInREM(20),
            padding: getPixelInREM(15)
        },
        filter: {
            [`&.MuiSkeleton-text`]: {
                borderRadius: 6
            }
        },
        listViewButton: {
            width: 100
        },
        table: {
            minHeight: getPixelInREM(300),
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            flexDirection: 'column'
        },
        row: {
            width: '100%',
            display: 'grid',
            gridAutoFlow: 'column',
            gap: 30,
            alignItems: 'center'
        },
        bar: {
            width: '100%',
            [`&.MuiSkeleton-text`]: {
                borderRadius: 25
            }
        },
        marginHorizontal10: {
            margin: `${getPixelInREM(10)} 0`
        },
        marginHorizontal5: {
            margin: `${getPixelInREM(5)} 0`
        }
    })
)
